import { ApiChartRankDrection, ApiDimension, ApiMetric, ApiOperator } from "@incendium/api"
import { ContentExplorer, ExplorerProvider } from "features/explorer"
import { TExploreConfig } from "features/explorer/types"
import { useHasSalesLastYear } from "features/analytics/hooks/useHasHadSales"
import { useMemo } from "react"

function GeoExplorerPage() {
  const { state, fetched } = useHasSalesLastYear()
  const metrics = useMemo(() => {
    if (!fetched) return []
    if (state.hasSalesLastYear) {
      return [
        ApiMetric.METRIC_SESSIONS_COUNT,
        ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
        ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
        ApiMetric.METRIC_MACRO_CONVERSION_RATE,
        ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_COUNT,
        ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_RATE,
        ApiMetric.METRIC_SALES_COUNT,
        ApiMetric.METRIC_REVENUE,
        ApiMetric.METRIC_AVERAGE_CWV_PERFORMANCE_SCORE,
        ApiMetric.METRIC_RANK,
      ]
    }
    return [
      ApiMetric.METRIC_SESSIONS_COUNT,
      ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
      ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
      ApiMetric.METRIC_MACRO_CONVERSION_RATE,
      ApiMetric.METRIC_AVERAGE_CWV_PERFORMANCE_SCORE,
      ApiMetric.METRIC_RANK,
    ]
  }, [fetched])

  const config: TExploreConfig<"Geographic"> =
    useMemo(() => {
      return {
        Geographic: {
          title: "Geographic",
          desc: "Uncover geographic insights and find problem/opportuinity locations.",
          ranking: [
            {
              label: "Opps",
              tooltip: "good performance but lower traffic",
              ranks: [
                {
                  metric: ApiMetric.METRIC_SESSIONS_COUNT,
                  direction: ApiChartRankDrection.DESC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  direction: ApiChartRankDrection.ASC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  direction: ApiChartRankDrection.ASC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_COUNT,
                  direction: ApiChartRankDrection.ASC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_SESSION_SALES_COUNT,
                  direction: ApiChartRankDrection.ASC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_REVENUE,
                  direction: ApiChartRankDrection.ASC,
                  weight: 0.1,
                },
              ],
            },
            {
              type: "bottom",
              label: "Problems",
              tooltip: "bad performance high traffic",
              ranks: [
                {
                  metric: ApiMetric.METRIC_SESSIONS_COUNT,
                  direction: ApiChartRankDrection.ASC,
                  weight: 0.2,
                },
                {
                  metric: ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  direction: ApiChartRankDrection.DESC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  direction: ApiChartRankDrection.DESC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_PAGE_ADD_TO_CART_CLICK_COUNT,
                  direction: ApiChartRankDrection.DESC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_SESSION_SALES_COUNT,
                  direction: ApiChartRankDrection.DESC,
                  weight: 0.1,
                },
                {
                  metric: ApiMetric.METRIC_REVENUE,
                  direction: ApiChartRankDrection.DESC,
                  weight: 0.1,
                },
              ],
            },
          ],
          default: [
            ApiMetric.METRIC_SESSIONS_COUNT,
            ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
            ApiMetric.METRIC_MACRO_CONVERSION_RATE,
          ],
          analyseBy: {
            description: "",
            grouping: [
              {
                option: "",
                dimensions: [
                  ApiDimension.DIMENSION_COUNTRY,
                  ApiDimension.DIMENSION_REGION,
                  ApiDimension.DIMENSION_CITY,
                ],
              },
            ],
          },
          having: {
            description: "Exclude results based on sessions or sales etc.",
            havings: [
              {
                label: "Min No. of sessions",
                metric: ApiMetric.METRIC_SESSIONS_COUNT,
                operator: ApiOperator.IS_GREATER_THAN_OR_EQUAL,
                value: undefined,
              },
              {
                label: "Max No. of sessions",
                metric: ApiMetric.METRIC_SESSIONS_COUNT,
                operator: ApiOperator.IS_LESS_THAN_OR_EQUAL,
                value: undefined,
              },
              {
                label: "Min No. of Sales",
                metric: ApiMetric.METRIC_SESSION_SALES_COUNT,
                operator: ApiOperator.IS_GREATER_THAN_OR_EQUAL,
                value: undefined,
              },
              {
                label: "Max No. of Sales",
                metric: ApiMetric.METRIC_SESSION_SALES_COUNT,
                operator: ApiOperator.IS_LESS_THAN_OR_EQUAL,
                value: undefined,
              },
            ],
          },
          attributes: [],
        },
      }
    }, [])
  return <ExplorerProvider configs={config} type={"Geographic"}>
    <ContentExplorer
      dimensionNoClick
      metrics={metrics}
      limit={1000}
    />
  </ExplorerProvider>
}

export default GeoExplorerPage